import React from "react";

// Material UI
import { TableCell, TableRow, TableHead, TableSortLabel } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";

export interface ITableColumn {
  id: string;
  value: string;
  index: number;
  numeric: boolean;
  label: string;
  type:
    | "date"
    | "string"
    | "number"
    | "object"
    | "image"
    | "icon"
    | "array"
    | "flightChip"
    | "eventChip"
    | "boolean"
    | "epochWithTimezone";
  width: number;
  visible: boolean;
  filter: boolean;
  sort?: boolean;
}

type Order = "asc" | "desc";
interface ITableHeaderProps {
  className?: any;
  classes?: any;
  numSelected: number;
  onRequestSort?: (event: React.MouseEvent<unknown>, property: keyof any) => void;
  onSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  order?: Order;
  orderBy?: any;
  rowCount: number;
  rowHeadings?: ITableColumn[];
  selectModeSingle?: boolean;
  hideSelectionCheckboxes?: boolean;
}

/**
 * Function that maps out the headings of the columns in the table and also allows users to display the data in a desc or asc order
 * @param props -
 */
export const TableHeader = (props: ITableHeaderProps): JSX.Element => {
  const {
    numSelected,
    order,
    orderBy,
    onRequestSort,
    onSelectAllClick,
    rowHeadings,
    rowCount,
    selectModeSingle,
    hideSelectionCheckboxes,
  } = props;
  const createSortHandler = (property: keyof any) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {!hideSelectionCheckboxes && (
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              disabled={!onSelectAllClick || selectModeSingle}
              inputProps={{ "aria-label": "Select all results" }}
            />
          </TableCell>
        )}
        {rowHeadings.map((row: ITableColumn) => (
          <TableCell sortDirection={orderBy === row.id ? order : false} key={row.id}>
            <TableSortLabel
              active={orderBy === row.id}
              direction={order}
              // @ts-ignore Error: Argument of type 'string' is not assignable to parameter of type '"_id" | "flightNumber" | ... 24 more ... | "altitude"'.
              onClick={createSortHandler(row.id)}
              hideSortIcon={true}
            >
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
